module.exports = __webpack_public_path__ + "static/media/010.fadce84b.jpg";